import { CuentaContableEmpresaReadingDtoProps } from "./DTOs/CuentaContableEmpresaReadingDto"
import { CuentaContableEmpresaReadingSimpleDtoProps } from "./DTOs/CuentaContableEmpresaReadingSimpleDto"

export const cuentaContableEmpresaAdapter = (
  cuentaContable: CuentaContableEmpresaReadingDtoProps
): CuentaContableEmpresaReadingDtoProps => ({
  id: cuentaContable.id,
  cuentaContablePadreNombre: cuentaContable.cuentaContablePadreNombre,
  cuentaContablePadreNumero: cuentaContable.cuentaContablePadreNumero,
  esBase: cuentaContable.esBase,
  grupoNombre: cuentaContable.grupoNombre,
  grupoNumero: cuentaContable.grupoNumero,
  nombre: cuentaContable.nombre,
  numero: cuentaContable.numero,
  porDefecto: cuentaContable.porDefecto,
  saldo: cuentaContable.saldo,
  subGrupoNombre: cuentaContable.subGrupoNombre,
  subGrupoNumero: cuentaContable.subGrupoNumero,
  totalDebe: cuentaContable.totalDebe,
  totalHaber: cuentaContable.totalHaber,
})

export const cuentaContableEmpresaIdAdapter = (
  cuentaContable: CuentaContableEmpresaReadingSimpleDtoProps
): CuentaContableEmpresaReadingSimpleDtoProps => ({
  id: cuentaContable.id,
  cuentaContableId: cuentaContable.cuentaContableId,
  nombre: cuentaContable.nombre,
  numero: cuentaContable.numero,
})
